module.exports = __webpack_public_path__ + "static/media/bbb.13532a55.png";